import { ref } from 'vue';

const activeFormId = ref(null);

export function useWhatsAppFormManager() {
  const openForm = (formId) => {
    activeFormId.value = formId;
  };

  const closeForm = () => {
    activeFormId.value = null;
  };

  const isFormActive = (formId) => {
    return activeFormId.value === formId;
  };

  return {
    openForm,
    closeForm,
    isFormActive,
  };
}